import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BetSlipComponent } from './betslip.component';
import { SportsbookFacadeService } from '../sportsbook/sportsbook-facade.service';

@Component({
  selector: 'app-betslip-mobile-dialog',
  standalone: true,
  imports: [BetSlipComponent],
  templateUrl: './betslip-mobile-dialog.component.html',
  styleUrl: './betslip-mobile-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BetslipMobileDialogComponent {
  protected readonly sportsbook = inject(SportsbookFacadeService);
  private readonly dialogRef = inject(MatDialogRef<BetslipMobileDialogComponent>);

  protected close(): void {
    this.dialogRef.close();
  }
}
